import React from "react";

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";

import { getPaymentSources } from 'actions/payment'


// material-ui components
import withStyles from "material-ui/styles/withStyles";
import FormControlLabel from "material-ui/Form/FormControlLabel";
import Radio from "material-ui/Radio";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  choiche: {
    textAlign: "center",
    cursor: "pointer",
    marginTop: "20px"
  },
  ...customSelectStyle,
  ...customCheckboxRadioSwitch
};

class Step3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      available: false,
      creditcards: [],
      creditcard:null,      
    };
    this.refreshSources = this.refreshSources.bind(this);
  }
  
  change = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.change({ [event.target.name]: event.target.value });
  };

  refreshSources(){
    this.props.dispatchGetPaymentSources(this.props.auth.user)
    .then( creditcards => {
      this.setState({creditcards});
    });  
  }

  componentDidMount() {
    this.refreshSources();
  }


  render() {
    const { classes } = this.props;
    return (
      <div>
        <h4 className={classes.infoText}>What is your availability?</h4>
        <GridContainer justify="center">
          <ItemGrid xs={12} sm={12} md={4}>
            {this.state.creditcards.map((prop,key)=>{
              return(
                    <FormControlLabel                    
                        key={key}                   
                        control={
                          <Radio
                            checked={this.state["creditcard"] === prop.id.toString()}
                            onChange={this.change}
                            value={prop.id.toString()}
                            name="creditcard"
                            aria-label={prop.creditcard}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label={prop.brand+" **** "+prop.last4+""}
                      />
                )
            })}
          </ItemGrid>     
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchGetPaymentSources: (user) => getPaymentSources(user),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
    userDetails: state.user.userDetails,
  }
}


export default compose(
  withStyles(style),
  connect(mapStateToProps, mapDispatchToProps)
)(Step3);






// WEBPACK FOOTER //
// ./src/views/Customer/AddShipmentWizardSteps/Step3.jsx